import React from "react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="font-heading text-3xl font-bold text-[#0A0A0A] md:text-4xl">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-[#6B6A6E] md:text-base">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
